module.exports = __webpack_public_path__ + "static/evnt-7b8f42951d8ede1d09dc69af9d603d3b.png";